import { render } from "./WithdrawRecords.vue?vue&type=template&id=0454bea6&scoped=true"
import script from "./WithdrawRecords.vue?vue&type=script&lang=js"
export * from "./WithdrawRecords.vue?vue&type=script&lang=js"

import "./WithdrawRecords.vue?vue&type=style&index=0&id=0454bea6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0454bea6"]])

export default __exports__